import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { InlineGrid } from '@marvelapp/marvel-ui/grid';
import Spacing from '@marvelapp/marvel-ui/spacing';
import MaxWidth from '@marvelapp/marvel-ui/max-width';

import ArrowLeft from 'marketing-website/components/icons/ArrowLeft';
import ArrowRight from 'marketing-website/components/icons/ArrowRight';
import Line from 'marketing-website/components/modules/Line';
import Image from 'marketing-website/components/modules/Image';
import SmartLink from 'marketing-website/components/modules/SmartLink';

import NavDropdownColumn from './NavDropdownColumn';

import styles from './style/mobile.module.css';

export default function MobileSecondaryNav({
  colHeading,
  currentlyOpen,
  resetCurrentlyOpen,
  ...item
}) {
  const cx = classNames.bind({ ...styles });
  const secondaryNav = cx(styles.secondaryContainer, {
    [styles.open]: item.firstColumnHeading === currentlyOpen,
  });
  const secondColumn = item.secondColumnItems;

  return (
    <div className={secondaryNav}>
      <MaxWidth value={280}>
        <Spacing type="margin" position="left" size="s">
          <div
            className={styles.menuHeading}
            as="h3"
            onClick={resetCurrentlyOpen}
          >
            <div className="marginRight-xs">
              <ArrowLeft />
            </div>
            {colHeading}
          </div>
        </Spacing>
        {item.image && (
          <Spacing type="margin" position="left" size="s">
            <Image
              src={item.image.src}
              alt={item.image.alt}
              maxWidth={264}
              hasShadow={false}
            />
            <Line spacing="m" />
          </Spacing>
        )}

        <NavDropdownColumn
          listItems={item.firstColumnItems}
          colHeading={item.firstColumnHeading}
          size="large"
        />
        {secondColumn && (
          <div>
            <Spacing type="margin" position="left" size="s">
              <Line spacing="m" position="bottom" />
            </Spacing>
            <NavDropdownColumn
              listItems={item.secondColumnItems}
              colHeading={item.secondColumnHeading}
              size="large"
            />
          </div>
        )}

        {item.footer && (
          <div className="fontSize-l marginBottom-m">
            <Spacing type="margin" position="left" size="s">
              <Line spacing="s" position="bottom" />

              <Spacing type="padding" position="top" size="s">
                <InlineGrid size="xs">
                  <SmartLink type="blue" url={item.footer.url}>
                    {item.footer.description}
                  </SmartLink>
                  <ArrowRight color="blue" height="8" />
                </InlineGrid>
              </Spacing>
            </Spacing>
          </div>
        )}
      </MaxWidth>
    </div>
  );
}

MobileSecondaryNav.propTypes = {
  colHeading: PropTypes.string,
  currentlyOpen: PropTypes.string,
  resetCurrentlyOpen: PropTypes.func,
  size: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/HeaderNav/MobileSecondaryNav.js